// src/App.tsx
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import WhatWeDoPage from './pages/WhatWeDoPage';
import GoalsPage from './pages/GoalsPage';
import ContactPage from './pages/ContactPage';
import ActivitiesPage from './pages/ActivitiesPage';
import ActivityDetailPage from './pages/ActivityDetailPage';
import CareersPage from './pages/CareersPage';
import JobDetailPage from './pages/JobDetailPage';
import Donate from './pages/Donate';

// Admin components
import Login from './components/Login';
import AdminLayout from './components/admin/AdminLayout';
import Dashboard from './components/admin/Dashboard';
import ActivityList from './components/admin/ActivityList';
import ActivityForm from './components/admin/ActivityForm';
import JobList from './components/admin/JobList';
import JobForm from './components/admin/JobForm';
import Blog from './components/admin/Blog';
import Settings from './components/admin/Settings';

import './App.css';

// Protected route component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = !!localStorage.getItem('token');
  return isAuthenticated ? <>{children}</> : <Navigate to="/admin/login" />;
};

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <div className="app">
        <Routes>
          {/* Admin login route - no navbar/footer */}
          <Route path="/admin/login" element={<Login />} />
          
          {/* Protected admin routes */}
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="activities" element={<ActivityList />} />
            <Route path="activities/new" element={<ActivityForm />} />
            <Route path="activities/edit/:id" element={<ActivityForm />} />
            <Route path="jobs" element={<JobList />} />
            <Route path="jobs/new" element={<JobForm />} />
            <Route path="jobs/edit/:id" element={<JobForm />} />
            <Route path="blog" element={<Blog />} />
            <Route path="settings" element={<Settings />} />
            {/* Redirect /admin to /admin/dashboard */}
            <Route index element={<Navigate to="dashboard" replace />} />
          </Route>
          
          {/* Public routes with navbar/footer */}
          <Route path="/" element={<><Navbar /><main><HomePage /></main><Footer /></>} />
          <Route path="/about" element={<><Navbar /><main><AboutPage /></main><Footer /></>} />
          <Route path="/what-we-do" element={<><Navbar /><main><WhatWeDoPage /></main><Footer /></>} />
          <Route path="/goals" element={<><Navbar /><main><GoalsPage /></main><Footer /></>} />
          <Route path="/activities" element={<><Navbar /><main><ActivitiesPage /></main><Footer /></>} />
          <Route path="/activities/:id" element={<><Navbar /><main><ActivityDetailPage /></main><Footer /></>} />
          <Route path="/careers" element={<><Navbar /><main><CareersPage /></main><Footer /></>} />
          <Route path="/careers/:id" element={<><Navbar /><main><JobDetailPage /></main><Footer /></>} />
          <Route path="/contact" element={<><Navbar /><main><ContactPage /></main><Footer /></>} />
          <Route path="/donate" element={<><Navbar /><main><Donate /></main><Footer /></>} />
        </Routes>
      </div>
    </HelmetProvider>
  );
};

export default App;